import Comp from './EqualHeight'

export default Comp
